import { render, staticRenderFns } from "./TabSubtitleHint.vue?vue&type=template&id=0c30383d&scoped=true&"
import script from "./TabSubtitleHint.vue?vue&type=script&lang=js&"
export * from "./TabSubtitleHint.vue?vue&type=script&lang=js&"
import style0 from "./TabSubtitleHint.vue?vue&type=style&index=0&id=0c30383d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30383d",
  null
  
)

export default component.exports